import request from '@/services/interceptor.js'

// ==========================
// Tipologie di scadenze
// ==========================
export const getTipologieScadenze = () => {
    return request({
        url: '/scadenze/tipologie',
        method: 'get',
    })
}

// ==========================
// CRUD Scadenze
// ==========================
export const getScadenze = (params) => {
    return request({
        url: '/scadenze',
        method: 'get',
        params,
    })
}

export const getScadenzaById = (id) => {
    return request({
        url: `/scadenze/${id}`,
        method: 'get',
    })
}

export const createScadenza = (data) => {
    return request({
        url: '/scadenze',
        method: 'post',
        data,
    })
}

export const updateScadenza = (id, data) => {
    return request({
        url: `/scadenze/${id}`,
        method: 'put',
        data,
    })
}

export const deleteScadenza = (id) => {
    return request({
        url: `/scadenze/${id}`,
        method: 'delete',
    })
}

export const duplicaScadenza = (id) => {
    return request({
        url: `/scadenze/${id}/duplica`,
        method: 'post',
    })
}

export const completaScadenza = (id) => {
    return request({
        url: `/scadenze/${id}/completa`,
        method: 'post',
    })
}

// ==========================
// Allegati
// ==========================
export const uploadAllegato = (scadenzaId, file) => {
    const formData = new FormData()
    formData.append('file', file)

    return request({
        url: `/scadenze/${scadenzaId}/allegati`,
        method: 'post',
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    })
}

export const getAllegati = (scadenzaId) => {
    return request({
        url: `/scadenze/${scadenzaId}/allegati`,
        method: 'get',
    })
}

export const deleteAllegato = (allegatoId) => {
    return request({
        url: `/scadenze/allegati/${allegatoId}`,
        method: 'delete',
    })
}

export const downloadAllegato = (allegatoId) => {
    return request({
        url: `/scadenze/allegati/${allegatoId}/download`,
        method: 'get',
        responseType: 'blob',
    })
}

// ==========================
// Lookup
// ==========================
export const getTarghe = () => {
    return request({
        url: '/lookup/targhe',
        method: 'get',
    })
}

export const getPc = () => {
    return request({
        url: '/lookup/pc',
        method: 'get',
    })
}

export const getOperatori = () => {
    return request({
        url: '/lookup/operatori',
        method: 'get',
    })
}



/**
 * Recupera una singola tipologia per ID
 */
export const getTipologia = (id) => {
    return request({
        url: `/scadenze/tipologie/${id}`,
        method: 'get',
    })
}

/**
 * Crea una nuova tipologia
 * @param {Object} tipologia
 */
export const createTipologia = (tipologia) => {
    return request({
        url: '/scadenze/tipologie',
        method: 'post',
        data: tipologia,
    })
}

/**
 * Aggiorna una tipologia esistente
 * @param {number} id
 * @param {Object} tipologia
 */
export const updateTipologia = (id, tipologia) => {
    return request({
        url: `/scadenze/tipologie/${id}`,
        method: 'put',
        data: tipologia,
    })
}

/**
 * Elimina una tipologia
 * @param {number} id
 */
export const deleteTipologia = (id) => {
    return request({
        url: `/scadenze/tipologie/${id}`,
        method: 'delete',
    })
}

/**
 * Duplica una tipologia
 * @param {number} id
 */
export const duplicaTipologia = (id) => {
    return request({
        url: `/scadenze/tipologie/${id}/duplica`,
        method: 'post',
    })
}

/**
 * Verifica quante scadenze utilizzano una tipologia
 * @param {number} id
 */
export const checkTipologiaUsage = (id) => {
    return request({
        url: `/scadenze/tipologie/${id}/usage`,
        method: 'get',
    })
}

/**
 * Aggiorna le scadenze esistenti con i nuovi valori di default della tipologia
 * @param {number} id
 * @param {boolean} aggiornaScadenze
 */
export const updateTipologiaScadenze = (id, aggiornaScadenze = false) => {
    return request({
        url: `/scadenze/tipologie/${id}/update-scadenze`,
        method: 'post',
        data: {
            aggiornaScadenze,
        },
    })
}


/**
 * Recupera il rinnovo attivo (prossimo) per una scadenza
 * @param {number} idScadenza
 */
export const getRinnovoAttivo = (idScadenza) => {
    return request({
        url: `/scadenze/${idScadenza}/rinnovi/attivo`,
        method: 'get',
    })
}

/**
 * Recupera lo storico rinnovi per una scadenza
 * @param {number} idScadenza
 */
export const getStoricoRinnovi = (idScadenza) => {
    return request({
        url: `/scadenze/${idScadenza}/rinnovi/storico`,
        method: 'get',
    })
}

/**
 * Conferma un rinnovo:
 * - sposta quello attivo in storico
 * - crea il prossimo rinnovo
 * @param {Object} confermaDto
 */
export const confermaRinnovo = (confermaDto) => {
    return request({
        url: '/scadenze/rinnovi/conferma',
        method: 'post',
        data: confermaDto,
    })
}

/**
 * Aggiorna un rinnovo attivo
 * @param {number} idRinnovo
 * @param {number} idScadenza
 * @param {Object} rinnovoDto
 */
export const updateRinnovo = (idRinnovo, idScadenza, rinnovoDto) => {
    return request({
        url: `/scadenze/rinnovi/${idRinnovo}/${idScadenza}`,
        method: 'put',
        data: rinnovoDto,
    })
}

/**
 * Elimina il rinnovo attivo di una scadenza
 * @param {number} idScadenza
 */
export const deleteRinnovoAttivo = (idScadenza) => {
    return request({
        url: `/scadenze/rinnovi/${idScadenza}`,
        method: 'delete',
    })
}

/**
 * Recupera tutti i rinnovi in scadenza entro N giorni
 * @param {number} giorni (default 30)
 */
export const getRinnoviInScadenza = (giorni = 30) => {
    return request({
        url: '/scadenze/rinnovi/in-scadenza',
        method: 'get',
        params: { giorni },
    })
}